import firebase from 'firebase';

import voucherCodes from 'voucher-code-generator';
import { request } from 'https';

const getCode = ()=>{
    let codes = voucherCodes.generate({
        length : 6,
        count : 1,
        charset : "23456789ABCDEFGHJKLMNPQRSTUVWXYZ"
    })
    return codes[0];
}
export const updateSelectedMapItem = (item)=>{
    return (dispatch)=>{
        dispatch({
            type : 'UPDATE_VOLUNTEER_MAP_SELECT',
            payload : item || {}
        })
    }
}


export const setVolunteerRequest = (searchResult, requestId) =>{
    return async (dispatch)=>{
        
        if(requestId){
            let req = {};
            searchResult.requests.map((r)=>{
                if(r.requestId==requestId){
                    searchResult.selectedRequest = r;
                }
            })
        }

        dispatch({
            type: 'SET_VOLUNTEER_REQUEST',
            payload : searchResult
        });

    
    }
}

export const cancelVolunteer = ()=>{
    return (dispatch)=>{
        dispatch({
            type : 'UPDATE_VOLUNTEER_PLEDGE',
            payload : null
        })
    }
}

/**
 * 
 * @param {string} charityId : Charity Id for the plesfw
 * @param {string} charityName : Name of charity
 * @param {string} requestId : Id of volunteer request
 * @param {string} requestTitle : Title of volunteer request/ slot request
 * @param {string} timeslotId  : (optional) If a specific time slot is requested
 * @param {string} locationId  : (optional) If a specific time slot is requested
 */
export const volunteer = (charityId, charityName, requestId, requestTitle,  timeslotId, locationId)=>{
    return async (dispatch, getState)=>{

        let item = getState().inventory.selectedRef;
        let user = getState().app.user

        return new Promise(async (resolve, reject)=>{
            dispatch({
                type : 'UPDATE_VOLUNTEER_PLEDGE',
                payload : {
                    ref : getCode(),
                    requestId : requestId,
                    status : 'pledged',
                    name : requestTitle,
                    quantity : 1,
                    givrEmail : user.email,
                    givrFirstName : user.firstName,
                    givrLastName : user.lastName,
                    charityId : charityId,
                    charityName : charityName,
                    timeslotId : timeslotId,
                    locationId : locationId || null
                }
            })
        })
    }
}


export const saveVolunteer = (donation)=>{
    return(dispatch)=>{

        return new Promise(async(resolve, reject)=>{
            
        

            try {

                let ref;

                if(!donation.id){
                    ref = firebase.firestore().collection('charities').doc(donation.charityId).collection('volunteerPledges').doc();
                    donation.createdAt =  firebase.firestore.FieldValue.serverTimestamp();
                    donation.id = ref.id;
                } else {
                    ref = firebase.firestore().collection('charities').doc(donation.charityId).collection('volunteerPledges').doc(donation.id);
                }

                donation.updatedAt = firebase.firestore.FieldValue.serverTimestamp();

                await ref.set(donation, { merge : true });

                resolve();

            }
            catch(e){
                console.error(e);
                reject(e)
            }
        

        })
        
    }
}


// WEBPACK FOOTER //
// ./src/actions/volunteerActions.js